module.exports = __webpack_public_path__ + "img/whats-new-53.11781d3.jpg";